import $store from '../store'
import redirectURL from './redirectUrl'
const guards = {}

guards.authenticate = async ({ meta, query }, from, next) => {
  if (meta.requireAuth) {
    try {
      const token = query.t || $store.getters['customer/token']
      if (token) {
        const { headerUrl } = await $store.dispatch('customer/setToken', token)
        $store.dispatch('app/getDynamicData', headerUrl)

        const path = query.t ? '/' : null
        next({ path })
      } else {
        window.location.href = redirectURL()
      }
    } catch (error) {
      console.error('Failed to login due to %s', error)
      window.location.href = process.env.VUE_APP_ERROR_REDIRECTION
    }
  }
}

export default guards
